import React from 'react';
import { Box } from '@honda-canada/design-system-react';
var MainContainer = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { bg: "transparent", mx: "auto" }, children));
};
export default MainContainer;
